<div class="top-padding header-font" *ngIf="extraData && !hideName">
  <a *ngIf="extraData.link" [href]="extraData.link" target="_blank">{{extraData.name || extraData.link}}</a>
  <a *ngIf="!extraData.link && extraData.route" [routerLink]="extraData.route">{{extraData.name}}</a>
  <div *ngIf="!extraData.link && !extraData.route && extraData.name">{{ extraData.name }}</div>
  <div *ngIf="extraData.data" [innerHTML]="extraData.data | safeHtml"></div>
</div>

<div class="top-padding header-font" *ngIf="extraData && hideName">
  <div *ngIf="extraData.data" [innerHTML]="extraData.data | safeHtml"></div>
</div>

